export default {
  trainingsItem: {
    name: null,
    year: null,
    notes: null
  },
  trainingsList: [],
  trainingsErrorsItem: {
    name: null,
    year: null,
    notes: null
  },
  trainingsErrorsList: []
};
